/**
 * Map name for mutations
 * @types {string}
 */

export const SET_NOTIFICATIONS = "NOTIFICATIONS/SET_NOTIFICATIONS";

export const SET_NOTIFICATIONS_ON_REQUEST =
  "NOTIFICATIONS/SET_NOTIFICATIONS_ON_REQUEST";
